import { useRef } from 'react'

import { NavLayout } from '@/components/layouts/NavLayout'
import { Footer } from '@/components/organisms/Footer'
import { NavLinks } from '@/types/navigation'

interface NavAndFooterLayoutProps {
  backgroundColor?: string
  links?: NavLinks
}

export const NavAndFooterLayout: React.FC<NavAndFooterLayoutProps> = ({
  backgroundColor,
  children,
  links,
}) => {
  const topOfPageRef = useRef<HTMLDivElement>(null)

  return (
    <NavLayout
      backgroundColor={backgroundColor}
      ref={topOfPageRef}
      links={links}
    >
      {children}
      <Footer />
    </NavLayout>
  )
}
